import { render, staticRenderFns } from "./children-list-drawer.vue?vue&type=template&id=8ecb60d2"
import script from "./children-list-drawer.vue?vue&type=script&lang=js"
export * from "./children-list-drawer.vue?vue&type=script&lang=js"
import style0 from "./children-list-drawer.vue?vue&type=style&index=0&id=8ecb60d2&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports